"use strict";

require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.join.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.object.keys.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getQueryString = void 0;
var getQueryString = exports.getQueryString = function getQueryString(params) {
  var esc = encodeURIComponent;
  return Object.keys(params).map(function (key) {
    var item = params[key];
    if (Array.isArray(item)) {
      return item.map(function (param) {
        return "".concat(esc(key), "=").concat(esc(param));
      }).join('&');
    }
    return "".concat(esc(key), "=").concat(esc(item));
  }).join('&');
};
//# sourceMappingURL=getQueryString.js.map